import { Link, LinkTarget } from "@Components/Link";
import type { IDiscountCouponBase} from "./DiscountCouponBase";
import { DiscountCouponType, DiscountCouponBase } from "./DiscountCouponBase";

export interface IDiscountCouponLink extends IDiscountCouponBase {
  linkText: string;
  linkUrl: string;
}

export class DiscountCouponLink extends DiscountCouponBase<IDiscountCouponLink> {
  protected couponType = DiscountCouponType.Link;

  protected renderCoupon = () => (
    <Link
      text={this.props.linkText}
      title={this.props.linkText}
      navigateUrl={this.props.linkUrl}
      hideMainLoading={true}
      target={LinkTarget.Blank}
    />
  );
}
